import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa"; // Import the eye icon for viewing details
import "./Agent-Registration.scss"; // Include your styling here
import apiService from "../../../global/common/environment";
import axiosInstance from "../../../global/common/interceptor";

const AgentRegistration = () => {
  const [Users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const getAllUsers = async () => {
    try {
      const res = await axiosInstance.get(apiService.getRegisteredOnlineAgents);
      setUsers(res.data.reverse()); // Latest first
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const handleViewDetails = (User) => {
    setSelectedUser(User);
    setShowDetails(true);
  };

  const handleCloseModal = () => {
    setShowDetails(false);
    setSelectedUser(null);
  };

  // Filter Users Before Pagination
  const filteredUsers = Users.filter((user) =>
    (user?.agencyName?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user?.keyContactEmail?.toLowerCase() || "").includes(searchQuery.toLowerCase())
  );

  // Ensure Pagination Resets on Search
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  // Pagination logic
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="admin-dashboard-container">
      <h1 className="dashboard-title">MakeStudy Online <br />Agent Registration Users</h1>

      {/* Search Bar */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by Agency Name or Email"
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <table className="admin-dashboard-table">
        <thead>
          <tr>
            <th>Agency Name</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Agent Unique ID</th>
            <th>Website URL</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((User, index) => (
              <tr key={index}>
                <td>{User?.agencyName || "N/A"}</td>
                <td>{User?.businessRegistrationNumber || "N/A"}</td>
                <td>{User?.keyContactEmail || "N/A"}</td>
                <td>{User?.agentUniqueId || "N/A"}</td>
                <td>{User?.websiteUrl || "N/A"}</td>
                <td>
                  <button className="view-details-btn" onClick={() => handleViewDetails(User)}>
                    <FaEye />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No Users found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <button 
          className={`prev-btn ${currentPage === 1 ? "disabled" : ""}`} 
          onClick={() => paginate(currentPage - 1)} 
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {Array.from({ length: Math.ceil(filteredUsers.length / itemsPerPage) }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => paginate(index + 1)}
            className={`page-number ${currentPage === index + 1 ? "active" : ""}`}
          >
            {index + 1}
          </button>
        ))}

        <button 
          className={`next-btn ${currentPage === Math.ceil(filteredUsers.length / itemsPerPage) ? "disabled" : ""}`} 
          onClick={() => paginate(currentPage + 1)} 
          disabled={currentPage === Math.ceil(filteredUsers.length / itemsPerPage)}
        >
          Next
        </button>
      </div>

      {/* Modal for Agent Details */}
      {showDetails && selectedUser && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>&times;</span>
            <h2>Agent Details</h2>
            <p><strong>Agency Name:</strong> {selectedUser?.agencyName || "N/A"}</p>
            <p><strong>Country of Registration:</strong> {selectedUser?.countryOfRegistration || "N/A"}</p>
            <p><strong>Email:</strong> {selectedUser?.emailAddress || "N/A"}</p>
            <p><strong>Business Address:</strong> {selectedUser?.businessAddress || "N/A"}</p>
            <p><strong>Office Phone Number:</strong> {selectedUser?.officePhoneNumber || "N/A"}</p>
            <p><strong>Website URL:</strong> {selectedUser?.websiteUrl || "N/A"}</p>
            <p><strong>WhatsApp Number:</strong> {selectedUser?.whatsappNumber || "N/A"}</p>
            <p><strong>Years in Business:</strong> {selectedUser?.yearsInBusiness || "N/A"}</p>
            <p><strong>Contact Full Name:</strong> {selectedUser?.keyContactFullName || "N/A"}</p>
            <p><strong>Contact Designation:</strong> {selectedUser?.keyContactDesignation || "N/A"}</p>
            <p><strong>Type of Business:</strong> {selectedUser?.typeOfBusiness || "N/A"}</p>
            <p><strong>Services Offered:</strong> {selectedUser?.servicesOffered || "N/A"}</p>
            <p><strong>Operating Regions:</strong> {selectedUser?.operatingRegions || "N/A"}</p>
            <p><strong>Students Recruited Last 12 Months:</strong> {selectedUser?.studentsRecruitedLast12Months || "N/A"}</p>
            <p><strong>Has Partnerships:</strong> {selectedUser?.hasPartnerships?.toString() || "N/A"}</p>
            <p><strong>Partnership Details:</strong> {selectedUser?.partnershipDetails || "N/A"}</p>
            <p><strong>Is Member of Associations:</strong> {selectedUser?.isMemberOfAssociations?.toString() || "N/A"}</p>
            <p><strong>Association Details:</strong> {selectedUser?.associationDetail || "N/A"}</p>
            <p><strong>Expectations from MakeStudy:</strong> {selectedUser?.expectationsFromMakeStudy || "N/A"}</p>
            <p><strong>How Did You Hear About Us:</strong> {selectedUser?.howDidYouHearAboutUs || "N/A"}</p>
            <p><strong>Declaration Consent:</strong> {selectedUser?.declarationConsent || "N/A"}</p>
            <p><strong>Declarant Name:</strong> {selectedUser?.declarantName || "N/A"}</p>
            <p><strong>Agent Unique ID:</strong> {selectedUser?.agentUniqueId || "N/A"}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentRegistration;
